const exerciseConstants = {
  // Títulos dos Seletores
  title: {
    admin: {
      pt: "PAINEL ADMIN - ",
      en: "ADMIN PANEL - ",
    },
    exerciseList: {
      pt: "Exercícios ",
      en: "Exercises ",
    },
    machine: {
      pt: "Máquinas",
      en: "Machines",
    },
    grammar: {
      pt: "Gramática",
      en: "Grammar",
    },
    regularExpressions: {
      pt: "Expressões Regulares",
      en: "Regular Expressions",
    },
  },

  // Tradução dos Tipos de Máquina (Usado no Select do Form)
  machineTypes: {
    AF: { pt: "Autômato Finito (AF)", en: "Finite Automaton (FA)" },
    AP: { pt: "Autômato de Pilha (AP)", en: "Pushdown Automaton (PDA)" },
    MT: { pt: "Máquina de Turing (MT)", en: "Turing Machine (TM)" },
    ALL: {
      pt: "Autômato Linearmente Limitado (ALL)",
      en: "Linear Bounded Automaton (LBA)",
    },
  },

  machineTypesShort: {
    AF: { pt: "AF", en: "FA" },
    AP: { pt: "AP", en: "PDA" },
    MT: { pt: "MT", en: "TM" },
    ALL: { pt: "ALL", en: "LBA" },
  },

  grammarTypes: {
    RG: { pt: "Gramática Regular (GR)", en: "Regular Grammar (RG)" },
    CFG: {
      pt: "Gramática Livre de Contexto (GLC)",
      en: "Context-Free Grammar (CFG)",
    },
    CSG: {
      pt: "Gramática Sensível ao Contexto (GSC)",
      en: "Context-Sensitive Grammar (CSG)",
    },
    UG: { pt: "Gramática Irrestrita (GI)", en: "Unrestricted Grammar (UG)" },
  },

  grammarTypesShort: {
    RG: { pt: "RG", en: "RG" },
    CFG: { pt: "GLC", en: "CFG" },
    CSG: { pt: "GSC", en: "CSG" },
    UG: { pt: "GI", en: "UG" },
  },

  // Componentes de Lista (Views)
  list: {
    empty: {
      pt: "Nenhum exercício cadastrado para este tipo.",
      en: "No exercises found for this category.",
    },
    author: {
      pt: "Autor: ",
      en: "Author: ",
    },
    noDescription: {
      pt: "Sem descrição disponível",
      en: "No description available",
    },
    filter: {
      labelText: {
        pt: "Filtrar por:",
        en: "Filter by:",
      },
      all: {
        pt: "Todos",
        en: "All",
      },
    },
  },

  // Formulário de Edição
  form: {
    editorTitle: {
      pt: "Editor de ",
      en: "Editor",
    },
    newRecord: {
      pt: "NOVO REGISTRO",
      en: "NEW RECORD",
    },
    labels: {
      author: { pt: "NOME DO AUTOR", en: "AUTHOR NAME" },
      simulator: { pt: "TIPO DE SIMULADOR", en: "SIMULATOR TYPE" },
      titlePt: { pt: "TÍTULO DO EXERCÍCIO (PT)", en: "EXERCISE TITLE (PT)" },
      titleEn: { pt: "TÍTULO DO EXERCÍCIO (EN)", en: "EXERCISE TITLE (EN)" },
      descPt: {
        pt: "DESCRIÇÃO E INSTRUÇÕES (PT)",
        en: "DESCRIPTION AND INSTRUCTIONS (PT)",
      },
      descEn: {
        pt: "DESCRIÇÃO E INSTRUÇÕES (EN)",
        en: "DESCRIPTION AND INSTRUCTIONS (EN)",
      },
      accepted: { pt: "Palavras Aceitas", en: "Accepted Words" },
      rejected: { pt: "Palavras Rejeitadas", en: "Rejected Words" },
      regex: { pt: "Expressão Regular", en: "Regular Expression" },
    },
    placeholders: {
      author: {
        pt: "Quem criou este exercício?",
        en: "Who created this exercise?",
      },
      titlePt: {
        pt: "Digite o título em Português...",
        en: "Enter the title in Portuguese...",
      },
      titleEn: {
        pt: "Digite o título em Inglês...",
        en: "Enter the title in English...",
      },
      descPt: {
        pt: "Instruções do desafio em Português...",
        en: "Challenge instructions in Portuguese...",
      },
      descEn: {
        pt: "Instruções do desafio em Inglês...",
        en: "Challenge instructions in English...",
      },
      acceptedHelp: {
        pt: "Separe por vírgula (ex: a, ab, abb)",
        en: "Separate by comma (ex: a, ab, abb)",
      },
      rejectedHelp: {
        pt: "Palavras que a solução NÃO deve aceitar",
        en: "Words the solution MUST NOT accept",
      },
      regex: { pt: "Ex: (a|b)*abb", en: "Ex: (a|b)*abb" },
    },
    validation: {
      pt: "GABARITO DE VALIDAÇÃO",
      en: "VALIDATION KEY",
    },
    errors: {
      required: {
        pt: "Este campo é obrigatório",
        en: "This field is required",
      },
      minWords: {
        pt: "Informe ao menos uma palavra",
        en: "Enter at least one word",
      },
    },
  },
  // HUD de Tarefa
  hud: {
    activeChallenge: {
      pt: "DESAFIO ATIVO",
      en: "ACTIVE CHALLENGE",
    },
    submit: {
      pt: "Enviar Resposta",
      en: "Submit Response",
    },
    success: {
      pt: "Resposta enviada com sucesso.",
      en: "Response submitted successfully.",
    },
    error: {
      pt: "Ops! A solução não atende aos requisitos.",
      en: "Oops! The solution does not meet requirements.",
    },
    connError: {
      pt: "Erro na conexão com o servidor.",
      en: "Server connection error.",
    },
  },

  // Botões Genéricos
  buttons: {
    save: { pt: "SALVAR ", en: "SAVE " },
    cancel: { pt: "CANCELAR", en: "CANCEL" },
    edit: { pt: "Editar", en: "Edit" },
    delete: { pt: "Excluir", en: "Delete" },
  },

  // Feedback do TaskResponse
  response: {
    errorTitle: {
      pt: "Erro de Validação:",
      en: "Validation Error:",
    },
    successTitle: {
      pt: "Resultado da Verificação:",
      en: "Verification Result:",
    },
    testsPassed: {
      pt: "Testes concluídos:",
      en: "Tests completed:",
    },
    showFailed: {
      pt: "Exibir testes que falharam",
      en: "Show failed tests",
    },
    failedTitle: {
      pt: "Palavras que falharam:",
      en: "Failed words:",
    },
    clickToSimulate: {
      pt: "Clique na palavra para simular",
      en: "Click word to simulate",
    },
    falsePositivesTitle: {
      pt: "Deveriam ser REJEITADAS (Falsos Positivos):",
      en: "Should be REJECTED (False Positives):",
    },
    falseNegativesTitle: {
      pt: "Deveriam ser ACEITAS (Falsos Negativos):",
      en: "Should be ACCEPTED (False Negatives):",
    },
    rating: {
      pt: "Taxa de acerto:",
      en: "Accuracy rate:",
    },
  },
};
export default exerciseConstants;
